import React from "react";
import { FiExternalLink } from "react-icons/fi";

const WebProjectCard = ({ name, category, image, readmore, reverse }) => {
  return (
    <div
      className={`w-full flex flex-col ${
        reverse ? "lg:flex-row-reverse" : "lg:flex-row"
      } lg:h-[581.7px] overflow-hidden rounded-2xl shadow-lg`}
    >
      {/* Text Panel */}
      <div className="relative flex flex-col justify-center w-full lg:w-[38%] lg:h-full px-6 py-8 sm:px-8 sm:py-10 bg-[#0b0f1a] overflow-hidden flex-shrink-0">
        {/* Dot pattern background */}
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "radial-gradient(circle, #0052D4 1px, transparent 1px)",
            backgroundSize: "22px 22px",
          }}
        />

        {/* Content */}
        <div className="relative z-10 overflow-hidden">
          {category && (
            <div className="flex items-center gap-2 mb-2">
              <span className="w-5 h-[2px] bg-[#00d084] block flex-shrink-0" />
              <span className="text-[10px] font-semibold tracking-[0.15em] uppercase text-[#00d084] truncate">
                {category}
              </span>
            </div>
          )}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-snug uppercase tracking-wide line-clamp-4">
            {name}
          </h2>
          {readmore && readmore !== "#" && (
            <a
              href={readmore}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center gap-2 text-xs font-medium text-[#6FB1FC] hover:text-white transition-colors duration-300"
            >
              <FiExternalLink className="text-sm flex-shrink-0" />
              Live Demo
            </a>
          )}
        </div>
      </div>

      {/* Image Panel */}
      <div className="relative w-full h-64 sm:h-80 lg:w-[62%] lg:h-full overflow-hidden flex-shrink-0">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover object-center transition-transform duration-700 hover:scale-105"
        />
        <div className="absolute inset-0 bg-black/0 hover:bg-black/10 transition-all duration-300" />
      </div>
    </div>
  );
};

export default WebProjectCard;
